import { ReturnActionType } from "../types/return-type";
import { LoginActionTypes } from "../types/login";

export const login = (): ReturnActionType => ({ type: LoginActionTypes.LOGIN });
